import ChartFetch from "@/components/HomeCharts/ChartFetch";
import DashboardImage from "@/components/LayoutCharts/DashboardImage";
import DialGuegeLayout from "@/components/LayoutCharts/DialGuegeLayout";
import Layout3DTank from "@/components/LayoutCharts/Layout3DTank";
import LayoutAlarmNotification from "@/components/LayoutCharts/LayoutAlarmNotification";
import LayoutCounter from "@/components/LayoutCharts/LayoutCounter";
import LayoutDynamicBox from "@/components/LayoutCharts/LayoutDynamicBox";
import LayoutLoadSummary from "@/components/LayoutCharts/LayoutLoadSummary";
import LayoutSplitCounter from "@/components/LayoutCharts/LayoutSplitCounter";
import LayoutTextBox from "@/components/LayoutCharts/LayoutTextBox";
import TableChart from "@/components/LayoutCharts/TableChart";
import Thermometer from "@/components/LayoutCharts/Thermometer";
import PropTypes from "prop-types";
import React from "react";

function DashboardPreview({ item }) {
  const preview = {
    bar: <ChartFetch data={item} type={item.component} />,
    line: <ChartFetch data={item} type={item.component} />,
    comboBar: <ChartFetch data={item} type={item.component} />,
    pie: <ChartFetch data={item} type={item.component} />,
    dial: <DialGuegeLayout data={item} />,
    splitCounter: <LayoutSplitCounter data={item} />,
    textBox: <LayoutTextBox data={item} />,
    html: <LayoutTextBox data={item} />,
    tank: <Layout3DTank data={item} />,
    dynamicBox: <LayoutDynamicBox data={item} />,
    loadSummary: <LayoutLoadSummary data={item} />,
    thermometer: <Thermometer data={item} />,
    table: <TableChart {...{ data: item }} />,
    counter: <LayoutCounter data={item} />,
    image: <DashboardImage data={item} />,
    alarmNotification: <LayoutAlarmNotification data={item} />,
  };

  return (
    <>
      {/* {item?.component} */}
      <>
        {item?.component === "iframe" ? (
          <iframe title="Dashboard" src={item?.iframe} style={{ width: "100%", height: "60vh" }}>
            Iframe does not supported
          </iframe>
        ) : (
          preview[item?.component]
        )}
      </>
    </>
  );
}

export default React.memo(DashboardPreview);

DashboardPreview.propTypes = {
  item: PropTypes.object,
  iframe: PropTypes.string,
};
